module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan2-2-f6c6451318dec71065bdeb66aeb18045.webp";